module.exports = __webpack_public_path__ + "img/2X.0b7f3907.jpg";